import { httpClient } from "../../../lib/http/axios";
import type { ApiEnvelope } from "../../../lib/http/contracts";
import {
  mapItineraryMySharePage,
  mapItineraryMyShareViewPage,
  type ItineraryMySharePageRaw,
  type ItineraryMyShareViewPageRaw,
} from "../api/adapters";
import type {
  ItineraryMySharePage,
  ItineraryMyShareQuery,
  ItineraryMyShareViewPage,
} from "../types/itineraryMyShare";

/** 读取当前员工的分享。 */
export async function listMyShares(query: ItineraryMyShareQuery): Promise<ItineraryMySharePage> {
  const response = await httpClient.get<ApiEnvelope<ItineraryMySharePageRaw>>(
    "/itineraries/shares/mine",
    { params: { page: query.page, page_size: query.pageSize, keyword: query.keyword } },
  );
  if (!response.data.data) throw new Error("分享列表响应为空");
  return mapItineraryMySharePage(response.data.data);
}

/** 读取当前员工某条分享的查看事件。 */
export async function listMyShareViews(
  shareId: string,
  page: number,
  pageSize: number,
): Promise<ItineraryMyShareViewPage> {
  const response = await httpClient.get<ApiEnvelope<ItineraryMyShareViewPageRaw>>(
    `/itineraries/shares/${encodeURIComponent(shareId)}/views`,
    { params: { page, page_size: pageSize } },
  );
  if (!response.data.data) throw new Error("查看明细响应为空");
  return mapItineraryMyShareViewPage(response.data.data);
}

/** 撤销本人分享，保持显式写操作不自动重试。 */
export async function revokeMyShare(shareId: string): Promise<void> {
  const response = await httpClient.post<ApiEnvelope<boolean>>(
    `/itineraries/shares/${encodeURIComponent(shareId)}/revoke`,
    undefined,
    { "axios-retry": { retries: 0 } },
  );
  if (response.data.data !== true) throw new Error("撤销分享未成功");
}
